import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class TopStudentsChart extends Component {

    getColor(index, total) {
        // green → yellow → red gradient
        const ratio = index / (total - 1);
        const r = Math.floor(255 * ratio);
        const g = Math.floor(200 * (1 - ratio));
        return `rgb(${r}, ${g}, 80)`;
    }

    getChartOptions() {
        const { data } = this.props;

        const sorted = [...data].sort((a, b) => b.total_marks - a.total_marks);

        const categories = sorted.map((s) => s.student_name);

        const marks = sorted.map((s, i) => ({
            y: s.total_marks,
            color: this.getColor(i, sorted.length)
        }));

        return {
            chart: {
                type: "bar",
                height: 450
            },

            title: {
                text: "Top Students Performance"
            },

            xAxis: {
                categories: categories,
                title: {
                    text: null
                }
            },

            yAxis: {
                min: 0,
                title: {
                    text: "Total Marks"
                }
            },

            tooltip: {
                formatter: function () {
                    const student = sorted[this.point.index];
                    return `
                        <b>${student.student_name}</b><br/>
                        Marks: ${student.total_marks}<br/>
                        Exams: ${student.no_of_exams}
                    `;
                }
            },

            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },

            series: [
                {
                    name: "Marks",
                    data: marks
                }
            ],

            credits: {
                enabled: false
            }
        };
    }

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getChartOptions()}
            />
        );
    }
}

export default TopStudentsChart;